import { FC } from 'react';

import { Skeleton } from '@mui/material';

const BundleHeaderBannerHighlightCoverSkeleton: FC = () => {
  return (
    <Skeleton
      animation="wave"
      variant="rectangular"
      sx={{ width: { lg: '487px' }, height: { xs: 184, md: 350, lg: 274 }, borderRadius: 2 }}
    />
  );
};

export default BundleHeaderBannerHighlightCoverSkeleton;
